import { useTranslation } from 'react-i18next';
import { Button, cn } from '@bliks-io/ui';

export function QueryErrorRetry({
  onRetry,
  loading,
  className
}: {
  onRetry: () => void;
  loading?: boolean;
  className?: string;
}) {
  const { t } = useTranslation();

  return (
    <div className={cn('flex flex-col items-center justify-center gap-4', className)}>
      <p className="text-sm text-destructive">{t('common.errorOccurred')}</p>
      <Button variant="outline" size="small" loading={loading} onClick={() => onRetry()}>
        {t('common.retry')}
      </Button>
    </div>
  );
}
